import React, { Component, useState, useEffect } from 'react'
import { Grid, Box, Menu, MenuItem } from '@mui/material/';

import Link from '@mui/material/Link';
import { Typography } from '@mui/material/';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';


import { useAuth } from "../hooks/useAuth";
import { AccountSelect, AccountSelectCheck } from "./AccountSelect";
import Logo from './Logo';
import firebaseConfig from "../config/firebaseConfig";


const preventDefault = (event) => event.preventDefault();

export default function NavTop() {
    const { user, claims } = useAuth();
    const navigate = useNavigate();
    const [punchoutAnchor, setPunchoutAnchor] = useState(null);
    
    const handlePunchoutClick = (event) => {
        setPunchoutAnchor(event.currentTarget);
    };
    
    const handlePunchoutClose = () => {
        setPunchoutAnchor(null);
    };
    
    const handlePunchoutMenuItemClick = (path) => {
        navigate(path);
        handlePunchoutClose();
    };

    return (
        <Box
            className="nav-top"
            sx={{
                p: 1, typography: 'body2',
            }}
        >
            <Grid container display="flex" spacing={2}>

                <Grid container item xs={12} md={6}
                    sx={{
                        mt: { xs: "10px" },
                        justifyContent: { xs: "center", md: "flex-start" },

                    }}
                    alignItems="center"
                >
                    <Link component={RouterLink} to={'/'} href="#">
                        <Logo />
                    </Link>
                </Grid>

                <Grid container item xs={12} md={6}

                    sx={{
                        display: 'flex',
                        justifyContent: { xs: "space-between", md: "flex-end", lg: "" },

                    }}
                    alignItems="center"
                >
                    <Grid
                        sx={{
                            display: 'flex',
                        }}
                        alignItems="center"
                    >

                        {user.displayName}
                        <AccountSelectCheck
                            sx={{
                                m: 1,
                                minWidth: 130,
                            }}
                        />
                    </Grid>

                    {/* Navigation links container */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        {/* First row - General links */}
                        <Box
                            sx={{
                                typography: 'body2', color: 'text.secondary', display: 'flex', mb: 0.5, mt: 1,
                                '& > :not(style) + :not(style)': {
                                    ml: 2,
                                },
                            }}
                        >
                            <Link component={RouterLink} to={'contact'} href="#">
                                Kontakt
                            </Link>

                            {firebaseConfig.projectId !== "litport-schoeningh" && (
                                <Link component={RouterLink} to={'faq'} href="#">
                                    FAQ
                                </Link>
                            )}

                            <Link component="a" href={firebaseConfig.imprintLink} target="_blank" rel="noopener noreferrer">
                                Impressum
                            </Link>
                        </Box>

                        {/* Second row - Admin/Management links */}
                        <Box
                            sx={{
                                typography: 'body2', color: 'text.secondary', display: 'flex', mb: 1, mt: 0.5,
                                '& > :not(style) + :not(style)': {
                                    ml: 2,
                                },
                            }}
                        >
                            {user && (claims?.role == "Admin" || claims?.role == "SuperAdmin") &&
                                <Link component={RouterLink} to={'user'}>
                                    User anzeigen
                                </Link>
                            }

                            {user && claims?.role === "SuperAdmin" &&
                                <Link component={RouterLink} to={'email-templates'}>
                                    E-Mail-Vorlagen
                                </Link>
                            }

                            {user && firebaseConfig.projectId !== "litport-schoeningh" && claims?.role === "SuperAdmin" && (
                                <Link component={RouterLink} to={'cart-configurator'}>
                                    Warenkorb-Konfigurator
                                </Link>
                            )}

                            {firebaseConfig.projectId === "litport-schoeningh" && claims?.role === "SuperAdmin" &&
                                <Link component={RouterLink} to={'data-import'}>
                                    Import Status
                                </Link>
                            }

                            {user && claims?.role === "SuperAdmin" && (
                                <>
                                    <Link
                                        component="button"
                                        onClick={handlePunchoutClick}
                                        sx={{ 
                                            display: 'flex', 
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            textDecoration: 'none',
                                            '&:hover': {
                                                textDecoration: 'underline'
                                            }
                                        }}
                                    >
                                        Punchout <ArrowDropDownIcon fontSize="small" />
                                    </Link>
                                    <Menu
                                        anchorEl={punchoutAnchor}
                                        open={Boolean(punchoutAnchor)}
                                        onClose={handlePunchoutClose}
                                        MenuListProps={{
                                            'aria-labelledby': 'punchout-button',
                                        }}
                                    >
                                        <MenuItem onClick={() => handlePunchoutMenuItemClick('/web/punchout-clients')}>
                                            Client Management
                                        </MenuItem>
                                        <MenuItem onClick={() => handlePunchoutMenuItemClick('/web/punchout-help')}>
                                            Punchout Hilfe
                                        </MenuItem>
                                    </Menu>
                                </>
                            )}
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box >

    );
}